import { render, staticRenderFns } from "./GarmentDevDetail.vue?vue&type=template&id=c05976d8&"
import script from "./GarmentDevDetail.vue?vue&type=script&lang=js&"
export * from "./GarmentDevDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports